import { ApiRoutes, QueryError } from '@/common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '@/common/services';

import { ReferralLink, ReferralLinksFormFields, ReferralLinksQueryKeys } from '@/modules/Sites';

export const useGetAllReferralLinksQuery = (siteId: string, referralId: string) =>
  buildQuery<ReferralLink[], QueryError>([ReferralLinksQueryKeys.GetAll, siteId, referralId], async () => {
    const { data } = await apiExecutor.get(
      ApiRoutes.ReferralLinks.replace(':siteId', siteId).replace(':referralId', referralId)
    );
    return data;
  });

export const useGetByIdReferralLinksQuery = (siteId: string, referralId: string, id: string) =>
  buildQuery<ReferralLink, QueryError>([ReferralLinksQueryKeys.Dossier, siteId, referralId, id], async () => {
    const { data } = await apiExecutor.get(
      ApiRoutes.ReferralLinksById
        .replace(':siteId', siteId)
        .replace(':referralId', referralId)
        .replace(':referralLinkId', id)
    );
    return data;
  });

export const useEditReferralLinksMutation = (siteId: string, referralId: string) =>
  buildMutation<
    ReferralLink[], QueryError, ReferralLinksFormFields
  >([ReferralLinksQueryKeys.Edit, siteId, referralId], async (postData) => {
    const { data } = await apiExecutor.put(
      ApiRoutes.ReferralLinks
        .replace(':siteId', siteId)
        .replace(':referralId', referralId),
      postData
    );
    return data;
  });

export const useBreadcrumbReferralLinksQuery = (siteId: string, referralId: string, id: string) =>
  buildQuery<string, QueryError>([ReferralLinksQueryKeys.Breadcrumb, siteId, referralId, id], async () => {
    const { data } = await apiExecutor.get(
      ApiRoutes.ReferralLinksBreadcrumb
        .replace(':siteId', siteId)
        .replace(':referralId', referralId)
        .replace(':referralLinkId', id)
    );
    return data;
  });
